import getImportLocationProgressStatus from 'state/progressImportLocations/actions';

const POLL_INTERVAL_MS = 1000;
const activePollers = new Map();
const addressLookupRequiredByImport = new Map();

const getProcessStatus = percent => (percent === 100 ? 'success' : 'active');

const fetchDatasetImport = async (pageId, importId) => {
  const response = await fetch('/graphql', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      query: `
        query DatasetImportPoll($id: ID!) {
          dataset(id: $id) {
            id
            imports {
              id
              fileName
              percentComplete
              processedCount
              totalCount
              unprocessedCount
              geocodedCount
              indexedCount
              notFoundCount
              errorMessage
            }
          }
        }
      `,
      variables: {
        id: pageId,
      },
    }),
  });

  const payload = await response.json();
  const imports = (((payload || {}).data || {}).dataset || {}).imports || [];

  return imports.find(item => String(item.id) === String(importId)) || null;
};

const stopPoller = (importId) => {
  const poller = activePollers.get(String(importId));

  if (poller) {
    clearTimeout(poller);
    activePollers.delete(String(importId));
    addressLookupRequiredByImport.delete(String(importId));
  }
};

const notifyImportChanged = (pageId, importId) => {
  window.dispatchEvent(new CustomEvent('dataset-import-updated', {
    detail: { pageId, importId },
  }));
};

export const CreateImportsChannelSubscriptions = (id, fileName, dispatch, pageId, closeModal) => {
  const importId = String(id);
  const clearProgress = () => dispatch(getImportLocationProgressStatus({}));
  const clearActiveImport = () => localStorage.removeItem(`${pageId}`);

  if (!pageId || activePollers.has(importId)) {
    if (closeModal) {
      closeModal();
    }
    return;
  }

  if (closeModal) {
    closeModal();
  }

  const poll = async () => {
    try {
      const importedFile = await fetchDatasetImport(pageId, importId);

      if (!importedFile) {
        stopPoller(importId);
        notifyImportChanged(pageId, importId);
        clearProgress();
        clearActiveImport();
        return;
      }

      const {
        percentComplete: percent,
        errorMessage,
        processedCount,
        totalCount,
        unprocessedCount,
        geocodedCount,
        indexedCount,
        notFoundCount,
      } = importedFile;
      const hasAddressLookupWork = unprocessedCount > 0 || notFoundCount > 0;
      const requiresAddressLookup = addressLookupRequiredByImport.get(importId)
        || hasAddressLookupWork;

      if (requiresAddressLookup) {
        addressLookupRequiredByImport.set(importId, true);
      }

      dispatch(getImportLocationProgressStatus({
        id: importId,
        percent,
        status: getProcessStatus(percent),
        fileName: importedFile.fileName || fileName,
        processedCount,
        totalCount,
        unprocessedCount,
        geocodedCount,
        indexedCount,
        notFoundCount,
        requiresAddressLookup,
        errorMessage,
      }));

      if (percent === 100 || errorMessage) {
        stopPoller(importId);
        notifyImportChanged(pageId, importId);
        clearProgress();
        clearActiveImport();
        return;
      }
    } catch (error) {
      stopPoller(importId);
      notifyImportChanged(pageId, importId);
      clearProgress();
      return;
    }

    activePollers.set(importId, setTimeout(poll, POLL_INTERVAL_MS));
  };

  activePollers.set(importId, setTimeout(poll, 0));
};
